'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackRegisterStart = trackRegisterStart;
exports.trackRegisterSuccessful = trackRegisterSuccessful;
function trackRegisterStart(langSource) {
  if (window.performance && typeof window.performance.mark === 'function') {
    window.performance.mark('mark_i18n_provider_register_start:' + langSource);
  }
}

function trackRegisterSuccessful(langSource) {
  try {
    var newrelic = window.newrelic;
    window.performance.mark('mark_i18n_provider_register_successful:' + langSource);
    window.performance.measure('measure_i18n_register_load_time:' + langSource, 'mark_i18n_provider_register_start:' + langSource, 'mark_i18n_provider_register_successful:' + langSource);
    var i18nRegisterLoadDuration = window.performance.getEntriesByName('measure_i18n_register_load_time:' + langSource)[0].duration;

    if (i18nRegisterLoadDuration && newrelic) {
      newrelic.setCustomAttribute('i18n-load-' + langSource, i18nRegisterLoadDuration);
    }
  } catch (e) {
    return;
  }

  return;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/js/init/internal/performanceTracking.js
// module id = 132
// module chunks = 177 178